module.exports = __webpack_public_path__ + "static/data-distribution-36e7a21f4c7ec8b2018cab87d77c62d6.svg";